import { supabase } from "@/lib/supabase";
import { throwOnSupabaseError } from "@/utils/errors";

export const rpcApi = {
  getUserByEmail: async (email: string) => {
    const { data, error } = await supabase.rpc('get_user_by_email', { p_email: email });

    throwOnSupabaseError(error);
    
    return data;
  }
}